// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__cw1Hv","title":"Info_title__2ZTKV","selects":"Info_selects__23iCA","requiredAsterisk":"Info_requiredAsterisk__3KOSr"};